import CloseIcon from "@mui/icons-material/Close";
import {
  Box,
  Button,
  IconButton,
  Modal,
  TextField,
  Typography,
} from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import * as Yup from "yup";
import { modalStyle } from "../../../utils/styles";

export default function ServiceTypeModal({ open, onClose, onSubmit, data }) {
  const formik = useFormik({
    initialValues: {
      name: data ? data.name : "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Service center type name is required"),
    }),
    onSubmit: (values) => {
      onSubmit(values, data?.id);

      formik.resetForm();
      onClose();
    },
  });
  return (
    <div>
      <Modal open={open} onClose={onClose}>
        <Box sx={modalStyle}>
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>

          <Typography id="modal-modal-title" variant="h6" component="h2">
            {data ? "Update Type" : "Add New Type"}
          </Typography>

          <form onSubmit={formik.handleSubmit}>
            <TextField
              fullWidth
              margin="normal"
              placeholder="Service Center Type Name"
              variant="outlined"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              sx={{ mt: 3 }}
            >
              {data ? "Update Service Center Type" : "Add New Service Center"}
            </Button>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
